<template>
    <div>
        <h2 class="mt-5 mb-2 text-gray-400 text-lg">Histórico de Liberações de Saque</h2>

        <filters
            v-model="filters"
            :loading="loading"
            @fetch="users = []; pagination.current_page = 1; fetch();"
            search-filter
            search-label="Filtre pelo nome ou email do usuário"
        ></filters>

        <div class="overflow-x-auto sm:-mx-6 lg:-mx-8 mt-4">
            <div class="inline-block min-w-full sm:px-6 lg:px-8">
                <div class="overflow-hidden not-prose relative bg-slate-50 rounded-xl overflow-hidden dark:bg-slate-800/25">
                    <table class="border-collapse table-auto w-full text-sm">
                        <thead>
                            <tr class="text-white">
                                <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                    #
                                </th>
                                <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                    Usuário
                                </th>
                                <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                    Email
                                </th>
                                <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                    Motivo
                                </th>
                                <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                    Data
                                </th>
                                <th scope="col" class="text-sm font-medium px-6 py-4 text-left">
                                    Ações
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white dark:bg-slate-800">
                            <tr v-if="loading">
                                <td colspan="6" class="text-center py-4 text-gray-400">
                                    Carregando...
                                </td>
                            </tr>
                            <tr v-else-if="users.length === 0">
                                <td colspan="6" class="text-center py-4 text-gray-400">
                                    Nenhuma liberação encontrada.
                                </td>
                            </tr>
                            <tr v-for="user in users" :key="user.id">
                                <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                    {{ user.id }}
                                </td>
                                <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                    <button
                                        class="text-indigo-500 hover:underline"
                                        @click.prevent="goToUser(user)"
                                    >
                                        {{ user.name }}
                                    </button>
                                </td>
                                <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                    {{ user.email }}
                                </td>
                                <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                    {{ getReleaseReason(user) }}
                                </td>
                                <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                    {{ getReleaseDate(user) }}
                                </td>
                                <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-200">
                                    <button
                                        class="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded"
                                        @click.prevent="goToUser(user)"
                                    >
                                        Ver Usuário
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="flex w-full my-5" v-if="pagination.total > 0">
                        <div class="flex flex-col items-center mx-auto">
                            <span class="mb-1 text-white">
                                Exibindo {{ pagination.from }} a {{ pagination.to }} registros de {{ pagination.total }}
                            </span>
                            <pagination
                                :pagination="pagination"
                                :offset="1"
                                @paginate="fetch"
                            ></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from "../../../components/layouts/Pagination.vue";
import Filters from "../../../components/layouts/Filters.vue";
import { mapWritableState } from "pinia";
import { Store } from "../../../stores/store";

export default {
    components: { Pagination, Filters },
    data() {
        return {
            loading: false,
            filters: {
                text: "",
            },
            users: [],
            pagination: {
                total: 0,
                per_page: 25,
                from: 0,
                to: 0,
                current_page: 1
            },
        };
    },

    computed: {
        ...mapWritableState(Store, ['user']),
    },

    mounted() {
        this.fetch();
    },

    methods: {
        fetch() {
            this.loading = true;
            const params = {
                ...this.filters,
                page: this.pagination.current_page
            };

            axios.get('/api/financial/cashout-release/history', { params })
                .then(({ data }) => {
                    this.users = data.data;
                    this.pagination = {
                        ...this.pagination,
                        total: data.total,
                        per_page: data.per_page,
                        from: data.from,
                        to: data.to,
                        current_page: data.current_page
                    };
                })
                .catch((error) => {
                    console.error('Erro ao carregar histórico:', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        goToUser(user) {
            if (!user) return;
            this.user = user;
            this.$router.push({
                name: 'user.commissions',
                params: { user_id: user.id }
            });
        },
        getReleaseReason(user) {
            const status = user.statuses?.[0];
            if (status?.description) {
                return status.description.replace('Saque liberado manualmente: ', '');
            }
            return '-';
        },
        getReleaseDate(user) {
            const status = user.statuses?.[0];
            return status?.created_at || user.updated_at || '-';
        }
    }
};
</script>
